export default "__VITE_PUBLIC_ASSET__29524aeb__"